import { LandingHeader } from './components/LandingHeader';
import { LandingHero } from './components/LandingHero';
import { LandingFeatures } from './components/LandingFeatures';
import { LandingFooter } from './components/LandingFooter';
import { landingStyles } from './landing.styles';

export const LandingPage = () => {
	return (
		<div style={landingStyles.container}>
			<LandingHeader />
			<LandingHero />
			<LandingFeatures />
			<LandingFooter />
		</div>
	);
};

